/** Strings for the subscription overview card (usage.subscription.overview). */
export const enSubscriptionOverview = {
	manageIntro:
		"Manage your plan, billing information and invoices. For questions, please contact <1>support@signalist.io</1>",
	currentPlan: "Current Plan: {{name}} ({{interval}})",
	trial: "Trial",
	creditsPerYearQuarter: "{{credits}} credits per year (billed every 3 months)",
	creditsPerYearSemi: "{{credits}} credits per year (billed every 6 months)",
	creditsPerYear: "{{credits}} credits per year",
	creditsPerMonth: "{{credits}} credits per month",
	trialNotice:
		'You are currently in your trial period. During the trial, you have access to a limited number of credits. Once your trial ends, you will receive the full credit amount included in your plan. Click "Skip Trial" to start your subscription immediately, or "Cancel Subscription" to end it when the trial is over — you will not be charged.',
	cancellationTrial:
		"Your subscription was canceled on {{canceledAt}}. You keep access until your trial ends on {{cancelAt}} and you will not be charged.",
	cancellationTrialScheduled:
		"Your subscription is scheduled to be canceled. You keep access until your trial ends on {{cancelAt}} and you will not be charged.",
	cancellationDiscount:
		"Your subscription was canceled on {{canceledAt}}. Your access will continue until the end of your current discount period on {{cancelAt}}.",
	cancellationBilling:
		"Your subscription was canceled on {{canceledAt}}. Your access will continue until the end of your current billing cycle on {{cancelAt}}.",
	cancellationNoEnd:
		"Your subscription was canceled on {{canceledAt}}. Your access will continue until the end of the current billing period.",
	cancellationDiscountScheduled:
		"Your subscription is scheduled to be canceled. Your access will continue until the end of your current discount period on {{cancelAt}}.",
	cancellationBillingScheduled:
		"Your subscription is scheduled to be canceled. Your access will continue until the end of your current billing cycle on {{cancelAt}}.",
	cancellationScheduled:
		"Your subscription is scheduled to be canceled and will end at the end of the current billing period.",
	nextBillingDate: "Next billing date: {{date}}",
	pendingPlanChange:
		"Plan change scheduled: from {{date}} your plan will switch to {{name}} ({{credits}} credits, billed {{interval}}). Until then your current plan stays active.",
	pendingPlanIntervals: {
		month: "monthly",
		quarter: "quarterly",
		half_year: "semi-annually",
		year: "annually",
	},
	changePlan: "Change plan",
	selectPlan: "Select Plan",
	skipTrial: "Skip Trial",
	skipping: "Skipping...",
	cancelSubscription: "Cancel Subscription",
	reactivateSubscription: "Reactivate Subscription",
	cancelConfirm: "Are you sure you want to cancel your subscription?",
	cancelConfirmTrial:
		"Are you sure you want to cancel? Your trial keeps running until it ends, and no payment will be taken.",
	cancelNoticeTrial:
		"Your trial ends on {{date}} and your subscription will be canceled then. You will not be charged.",
	cancelNoticeTrialNoDate:
		"Your subscription will be canceled at the end of your trial period. You will not be charged.",
	cancelNoticeBilling:
		"Your access will continue until the end of your current billing cycle on {{date}}.",
	cancelNoticeBillingNoDate:
		"Your access will continue until the end of your current billing cycle.",
	cancelNoticeDiscountLabelAndEnd:
		"You have an active discount ({{label}}) that runs until {{discountEnd}}. Your subscription will remain active until the end of this discount period.",
	cancelNoticeDiscountEnd:
		"You have an active discount that runs until {{discountEnd}}. Your subscription will remain active until the end of this discount period.",
	cancelNoticeDiscountLabel:
		"You have an active discount ({{label}}). Your subscription will remain active until the end of this discount period.",
	cancelNoticeDiscount:
		"You have an active discount. Your subscription will remain active until the end of this discount period.",
	cancelNoticeDataRetention: "After that, your data will be preserved for 30 days.",
	installmentCommitmentError: "Installment subscriptions have a 12-month minimum commitment.",
	cancelFailed: "Failed to cancel subscription. Please try again or contact support.",
	reactivateFailed: "Failed to reactivate subscription. Please try again or contact support.",
	reactivatedSuccess: "Your subscription has been reactivated.",
};
